import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  name: 'CmgRecaptcha',
})
/* ONLY imports the recaptcha. Make sure this is present in a parent but use vue-recaptcha to display */
export default class CmgRecaptcha extends Vue {
  mounted() {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onLoad=vueRecaptchaApiLoaded&render=explicit');
    recaptchaScript.setAttribute('async', 'async');
    recaptchaScript.setAttribute('defer', 'defer');
    (this.$refs.cmgRecaptchaScriptContainer as HTMLElement).appendChild(recaptchaScript);
  }
}